<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import apigeneric from "@/helpers/apigeneric";
    import Loader from "@/components/widgets/loader";
    import Banner from "../components/banner";
    import apibtoast from "@/helpers/apibtoast";
    
    export default {
      page: {
        title: "Web Siteleri",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        Loader,
        Banner
    
      },
      mixins: [apigeneric, apibtoast],
      data() {
        return {
          TableData: {},
          PersonellerTitle: {},
          DefaultPage: 1,
          Page: {
            PageNumber: "1",
            PageSize: "10",
            PageDataSize: "1",
          },
          currentUrl: null
          
  
          
        };
      },
      created() {
    this.currentUrl = window.location.host;
    },
      methods: {
        Get() {

           this.ActionsFilterGet({
                Service: "IdariPersonel",
                Page: this.Page,
                Filter: "&Siteurl=http://" + this.currentUrl
            }).then((res) => {
                this.TableData = res.Data;
                this.Page.PageDataSize = res.TotalCount;
            });
  
            
          }
      },
    };
    </script>
        
    <template>
      <Loader>
        <Layout>
          <Banner /> 
          <div class="title c-flex flex-column mt-5">
                <h2>{{$t("Personeller.FakulteYonetimKurulu.Title")}}</h2>
            </div> 
            <div class="row mt-5 mb-3">
                       <div id="card" class="card bg-gradient text-light text-center " v-for="(Data,index) in TableData" :key="index" style="background-color:#2774AE; box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
                            <div>
                           <img v-if="Data.Foto" class="card-img-top mt-2" :src="$config.FILES_URL + 'web/'+ Data.Foto" alt="Personel image" style="width:100%; border-radius:10px">
                           <img v-if="Data.Foto==null" class="card-img-top mt-2" src="@/assets/images/personelicon.png" alt="Personel image" style="width:100%; border-radius:10px">
                         </div>
                           <div class="card-body">
                              <h4 class="card-title text-light xs">{{ Data.Adsoyad }}</h4>
                              <p class="card-text">{{Data.Mail}}</p>
                           </div>
                        </div>
                  </div>
        </Layout>
      </Loader>
    </template>

    <style>
      #card {
        max-width: 250px;
        margin-right: 10px ;
        margin-left: 40px ;
        
      }
    </style>
        